class OpeningClass {
    constructor() {
        this.id = this.generateId();
        this.type = 'door';
        this.height = '';
        this.width = '';
        this.depth = '';
        this.floor_distance = '';
        this.area = '';
        this.perimeter = '';
        this.slope_area = '';
        this.slope_perimeter = '';
    }

    generateId() {
        return 'id_' + Math.random().toString(36).substr(2, 9);
    }

    toPlainObject() {
        return {
            id: this.id,
            type: this.type,
            height: this.height,
            width: this.width,
            depth: this.depth,
            floor_distance: this.floor_distance,
            area: this.area,
            perimeter: this.perimeter,
            slope_area: this.slope_area,
            slope_perimeter: this.slope_perimeter,
            isNew: true,
        };
    }
}

export default OpeningClass;
